import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  current_year = (new Date()).getFullYear();

  changeColor: boolean = true;


  constructor(private router: Router) {
  }

  ngOnInit() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {

        if (
          (event['url'].includes('/welcome') || event['urlAfterRedirects'].includes('/welcome'))
        ) {
          this.changeColor = true;
        } else {
          this.changeColor = false;
        }

      }
    });
  }

}
